import React, { useMemo, useCallback } from "react"
import { useDispatch, useSelector } from "react-redux"

import BusRow from "./rows/bus"
import OrderRow from "./rows/order"
import PartialRow from "./rows/partial"
import { setSort } from "redux/warehouse/warehouseSlice"

// memoize once, at module scope
const MemoBusRow = React.memo(BusRow)
const MemoOrderRow = React.memo(OrderRow)
const MemoPartialRow = React.memo(PartialRow)

export const WarehouseTraffic = () => {
  const dispatch = useDispatch()
  const { display, warehouse, traffic, loading, error } = useSelector(s => s.warehouse)

  // handler
  const startSort = useCallback(
    col => dispatch(setSort(col)),
    [dispatch]
  )

  // outgoing / incoming
  const keyBase = display.toLowerCase()

  const partials = (traffic[`${keyBase}_partials`] || [])
    .map(p => <PartialRow partial={p} key={`p-${p.id}`} />)

  const buses = (traffic[`${keyBase}_buses`] || [])
    .map(b => <BusRow bus={b} key={`b-${b.id}`} />)

  const orders = (traffic[`${keyBase}_orders`] || [])
    .map(o => <OrderRow order={o} key={`o-${o.id}`} />)

  if (error) return <div className="p-4 text-red-600">Error: {error}</div>

  return (
    <div className="warehouse-table-container">
      <table className="warehouse-dashboard-table">
        <thead>
          <tr>
            {display === "Incoming" && (
              <>
                <th onClick={() => startSort("bus")} className="warehouse-column-sortable">Inbound</th>
                {warehouse === "Laredo" && (
                  <th onClick={() => startSort("trailer_placas")} className="warehouse-column-sortable">Trailer</th>
                )}
              </>
            )}
            <th onClick={() => startSort("dock")} className="warehouse-column-sortable">On Dock</th>
            <th onClick={() => startSort("order_no")} className="warehouse-column-sortable">Pro (B)</th>
            {display === "Outgoing" && (
              <th onClick={() => startSort("bus")} className="warehouse-column-sortable">Outbound</th>
            )}
            <th onClick={() => startSort("deliver_to")} className="warehouse-column-sortable">Deliver To</th>
            {display === "Outgoing" && (
              <th onClick={() => startSort("scheduled_pickup")} className="warehouse-column-sortable">Scheduled Pickup</th>
            )}
            <th onClick={() => startSort("units")} className="warehouse-column-sortable">Skids</th>
            <th>Weight [lbs]</th>
            <th>Actions</th>
            <th onClick={() => startSort("notes")} className="warehouse-column-sortable">Notes</th>
          </tr>
        </thead>
        {
          partials.length > 0 && (
            <>
              <thead>
                <tr>
                  <th colSpan={9} style={{}}>Partials</th>
                </tr>
              </thead>
              <tbody>{partials}</tbody>
            </>
          )
        }

        {
          buses.length > 0 && (
            <>
              <thead>
                <tr>
                  <th colSpan={9} style={{}}>Buses</th>
                </tr>
              </thead>
              <tbody>{buses}</tbody>
            </>
          )
        }
        {
          orders.length > 0 && (
            <>
              <thead>
                <tr>
                  <th colSpan={9} style={{}}>Orders</th>
                </tr>
              </thead>
              <tbody>{orders}</tbody>
            </>
          )
        }
      </table>
    </div>
  )
}
